(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/input-number/assets/javascripts/components/input-number-input.js') >= 0) return;  svs.modules.push('/components/components/input-number/assets/javascripts/components/input-number-input.js');
"use strict";

const InputNumberInput = _ref => {
  let maxValue = _ref.maxValue,
    size = _ref.size,
    transparent = _ref.transparent,
    block = _ref.block,
    inverted = _ref.inverted,
    minValue = _ref.minValue,
    onInputBlur = _ref.onInputBlur,
    onInputChange = _ref.onInputChange,
    onInputFocus = _ref.onInputFocus,
    onInputKeyDown = _ref.onInputKeyDown,
    isStepOnly = _ref.isStepOnly,
    value = _ref.value;
  const classNames = ['btn', "btn-".concat(size)];
  if (block) {
    classNames.push('btn-block');
  }
  if (transparent && inverted) {
    classNames.push('btn-transparent-inverted');
    classNames.push('input-number-input-is-transparent-inverted');
  } else if (transparent) {
    classNames.push('btn-transparent-default');
  } else if (inverted) {
    classNames.push('btn-transparent-default');
  } else {
    classNames.push('btn-transparent-default');
    classNames.push('input-number-input-is-focus');
  }
  return React.createElement("input", {
    className: "input-number-input ".concat(classNames.join(' ')),
    max: maxValue,
    min: minValue,
    onBlur: onInputBlur,
    onChange: onInputChange,
    onFocus: onInputFocus,
    onKeyDown: onInputKeyDown,
    readOnly: isStepOnly,
    type: "number",
    value: value
  });
};
svs.components.input_number.InputNumberInput = InputNumberInput;

 })(window);